import React, {useEffect, useState} from 'react';
import './TutorialDamageDice.css';
import DamageDice from '../../TokensToolbar/DamageDice/DamageDice';
import {DAMAGE_DICE_FACE_LAYOUT} from '../../../utils/dice/damageDiceOrientation';

// Значения граней кости урона в порядке рассказа о ней: от худшей к лучшей
export const TUTORIAL_DICE_FACE_VALUES = DAMAGE_DICE_FACE_LAYOUT
  .map(({value}) => value)
  .sort((a, b) => a - b);

// Как часто кость витрины сама перекручивается и сколько длится поворот.
// Пауза заметно длиннее поворота: кость должна выглядеть живой, но не
// мельтешить под текстом правила
export const TUTORIAL_DICE_SPIN_INTERVAL_MS = 2600;
export const TUTORIAL_DICE_TURN_DURATION_MS = 900;

// Грань, отличная от текущей: поворот на то же значение не сдвинул бы куб
// (ориентация считается от значения), и «перекручивание» пропало бы
const getNextFaceValue = (currentValue) => {
  const otherValues = TUTORIAL_DICE_FACE_VALUES.filter((value) => value !== currentValue);
  return otherValues[Math.floor(Math.random() * otherValues.length)];
};

/**
 * Кость урона в обучающих модалках — тот же псевдо-3D кубик, что в футере боя
 * (DamageDice), но только для показа: кликать, выбирать и перебрасывать ее
 * нельзя.
 *
 * isSpinning — кость время от времени сама поворачивается новой гранью к
 * зрителю. Без кувырка с подлетом, как у настоящего переброса: это не бросок,
 * а иллюстрация к правилу, и подпрыгивающий кубик посреди текста отвлекал бы.
 *
 * isInline — кость стоит прямо в строке текста (результат броска, слагаемое
 * формулы): такая мельче значка легенды и выравнивается по строке.
 */
export const TutorialDamageDice = ({
  value = TUTORIAL_DICE_FACE_VALUES[0],
  isSpinning = false,
  isInline = false,
}) => {
  const [spinningValue, setSpinningValue] = useState(value);

  useEffect(() => {
    if (!isSpinning) {
      return undefined;
    }
    const intervalId = setInterval(
      () => setSpinningValue(getNextFaceValue),
      TUTORIAL_DICE_SPIN_INTERVAL_MS,
    );
    return () => clearInterval(intervalId);
  }, [isSpinning]);

  return (
    <span className={`tutorial-damage-dice ${isInline ? 'tutorial-damage-dice_inline' : ''}`}>
      <DamageDice
        damage={isSpinning ? spinningValue : value}
        isPresentation={true}
        turnDurationMs={isSpinning ? TUTORIAL_DICE_TURN_DURATION_MS : undefined}
      />
    </span>
  );
};

/**
 * Все шесть граней кости урона — по кубику на грань, каждый повернут своим
 * значением к зрителю. Наглядно вместо перечисления значений текстом
 */
export const TutorialDamageDiceFaces = () => (
  <span className={'tutorial-damage-dice-faces'}>
    {TUTORIAL_DICE_FACE_VALUES.map((faceValue, index) => (
      <TutorialDamageDice key={`${faceValue}_${index}`} value={faceValue}/>
    ))}
  </span>
);

export default TutorialDamageDice;
